export default {
    _prefix: "qualityFormEditor.questionGroup",
    labels: {
        name: "Question Group Name",
        scoring: "Scoring Options",
        questionGroupPropertiesTitle: "Question Group Properties",
        enableNA: "N/A Enabled Question Group",
        groupScoringTitle: "Answers Default To",
        addPoints: "Start at 0% and add points",
        subtractPoints: "Start at 100% and subtract points",
        questionGroupName: "Question Group Name",
        questionCount: " {{questionCount}} Question(s)",
        totalPoints: "Total Points: {{#ScoreTag}}{{/ScoreTag}}",
        delete: "Delete",
        done: "Done",
        defaultHighestScoring: "Highest Scoring",
        defaultLowestScoring: "Lowest Scoring",
        defaultUserDefined: "User Defined",
        defaultNA: "N/A",
        infoBanner: {
            defaultAnswersToMessage:
                "Note: Only N/A and Highest Scoring can be chosen together. Lowest Scoring and User Defined must be chosen alone. Selections will disable incompatible options.",
        },
        tooltip: {
            disabledDefaultAnswerToOptions: "Disabled due to current selection",
        },
        logic: {
            title: "Logic",
            displayConditionally: "Display This Question Group Conditionally",
            includeConditionally: "Include This Question Group Conditionally",
        },
    },
    error: {
        nameRequired: "This field is required.",
        nameTooLong: (maxQuestionGroupNameLength: {
            maxQuestionGroupNameLength: number;
        }) =>
            "Question group name cannot exceed {{maxQuestionGroupNameLength}} characters.",
        answersDefaultToRequired:
            "Answers Default To must be selected for auto-submission forms",
    },
};
